export default "__VITE_ASSET__Bm6TrqF3__"